import { render } from "./Practices.vue?vue&type=template&id=53600627&scoped=true"
import script from "./Practices.vue?vue&type=script&lang=js"
export * from "./Practices.vue?vue&type=script&lang=js"

import "./Practices.vue?vue&type=style&index=0&id=53600627&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53600627"]])

export default __exports__